import styled from "@emotion/styled";
import { arrayOf, shape, string } from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import theme from "../../theme";
import Heading from "../Heading";
import AwardGif, { awardGif } from "./components/AwardGif";
import AwardLogo, { awardLogo } from "./components/AwardLogo";

const Wrapper = styled.div`
  position: relative;
`;

const Slider = styled.div`
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${theme.color("primary.base")};
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
`;

const LogoContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.space("m")};
  pointer-events: none;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: ${theme.spacing("s")};
  padding: 0 ${theme.spacing("sm")};
`;

const AwardsCarousel = ({ title, items, ...props }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [itemWidth, setItemWidth] = useState(900);
  const containerRef = useRef();

  const handleScroll = (event) => {
    setScrollPosition(event.target.scrollLeft);
    setItemWidth(event.target.offsetWidth);
  };

  useEffect(() => {
    setItemWidth(containerRef.current.offsetWidth);
  }, [containerRef]);

  return (
    <Wrapper {...props}>
      {title && <StyledHeading size={2}>{title}</StyledHeading>}
      <Slider>
        <Container ref={containerRef} onScroll={handleScroll}>
          {items.map(({ id, image }) => (
            <AwardGif key={`awardImage-${id}`} image={image} />
          ))}
        </Container>
        <LogoContainer
          style={{
            paddingLeft: `${(itemWidth - 200) / 2}px`,
            transform: `translateX(-${
              (scrollPosition / itemWidth) *
              (33 + (itemWidth - (itemWidth - 200)))
            }px)`,
          }}
        >
          {items.map(({ id, logo }) => (
            <AwardLogo key={`awardLogo-${id}`} logo={logo} />
          ))}
        </LogoContainer>
      </Slider>
    </Wrapper>
  );
};

AwardsCarousel.propTypes = {
  title: string,
  items: arrayOf(
    shape({
      id: string,
      ...awardGif,
      ...awardLogo,
    })
  ),
};

export default AwardsCarousel;
